import type { RouteRecordRaw } from 'vue-router';
import { EMBED_BRIDGE_PATH, HOME_URL } from '@/config';

// LayoutRouter[布局路由]
export const layoutRouter: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: HOME_URL,
    component: () => import('@/layouts/index.vue'),
    children: [
      {
        path: HOME_URL,
        name: 'chat',
        component: () => import('@/pages/chat/index.vue'),
        meta: {
          title: 'chat',
          updateTitle: false,
          isDefaultChat: true,
          icon: 'HomeFilled',
          // isHide: '1', // 是否在菜单中隐藏[0是，1否] 预留
          // isKeepAlive: '0', // 是否缓存路由数据[0是，1否] 预留
          // isFull: '1', // 是否全屏[0是，1否] 预留
          // enName: "Master Station", // 英文名称 预留
        },
      },
      {
        path: '/chat/:agentId/:conversationId',
        name: 'chatWithAgentAndConversation',
        component: () => import('@/pages/chat/index.vue'),
        meta: {
          title: 'chat',
          updateTitle: false,
          isDefaultChat: false,
        },
      },
      {
        path: '/chat/:agentId',
        name: 'chatWithAgent',
        component: () => import('@/pages/chat/index.vue'),
        meta: {
          title: 'chat',
          updateTitle: false,
          isDefaultChat: false,
        },
      },
      {
        path: '/experts',
        name: 'experts',
        component: () => import('@/pages/experts/index.vue'),
        meta: {
          title: 'experts',
          updateTitle: false,
          isDefaultChat: false,
          keepAlive: false,
        },
      },
      {
        path: '/experts/:agentId/chat/:conversationId',
        name: 'expertChat',
        component: () => import('@/pages/expert-chat/index.vue'),
        meta: {
          title: 'experts',
          updateTitle: false,
          isDefaultChat: true,
          keepAlive: false,
        },
      },
      {
        path: '/resources',
        name: 'resources',
        component: () => import('@/pages/resources/index.vue'),
        meta: {
          title: 'resources',
          updateTitle: false,
          isDefaultChat: false,
          keepAlive: false,
        },
      },
      {
        path: '/skills',
        redirect: (to) => ({
          path: '/resources',
          query: { ...to.query, tab: 'skills' },
        }),
      },
      {
        path: '/connectors',
        redirect: (to) => ({
          path: '/resources',
          query: { ...to.query, tab: 'connectors' },
        }),
      },
      {
        path: '/automation',
        name: 'automation',
        component: () => import('@/pages/automation/index.vue'),
        meta: {
          title: 'automation',
          updateTitle: false,
          isDefaultChat: false,
          keepAlive: false,
        },
      },
      {
        path: '/apps',
        name: 'apps',
        component: () => import('@/pages/apps/index.vue'),
        meta: {
          title: 'apps',
          updateTitle: false,
          isDefaultChat: false,
          keepAlive: false,
        },
      },
      {
        path: '/apps/:id/:slug?',
        name: 'apps-detail',
        component: () => import('@/pages/apps/index.vue'),
        meta: {
          title: 'apps',
          updateTitle: false,
          isDefaultChat: false,
          keepAlive: false,
        },
      },
      {
        path: '/task/:id',
        redirect: to => ({
          path: '/automation',
          query: {
            ...to.query,
            task: to.params.id as string,
          },
        }),
      },
      {
        path: '/notification',
        name: 'notification',
        component: () => import('@/pages/notification/index.vue'),
        meta: {
          title: 'notification',
          updateTitle: false,
          isDefaultChat: false,
          keepAlive: false,
        },
      },
      {
        path: '/knowledge',
        redirect: (to) => ({
          path: '/resources',
          query: { ...to.query, tab: 'knowledge' },
        }),
      },
      {
        path: '/knowledge/:id',
        name: 'knowledge-detail',
        component: () => import('@/knowledge/views/KnowledgeDetailView.vue'),
        meta: {
          title: 'knowledgeDetail',
          updateTitle: false,
          isDefaultChat: false,
          keepAlive: false,
        },
      },
      {
        path: '/dev',
        name: 'dev',
        component: () => import('@/pages/dev/index.vue'),
        meta: {
          title: 'dev',
          updateTitle: false,
          isDefaultChat: false,
          keepAlive: false,
        },
      },
      {
        path: '/dev/datahub',
        name: 'dev-datahub',
        component: () => import('@/pages/dev/embed.vue'),
        meta: {
          title: 'dev',
          updateTitle: false,
          isDefaultChat: false,
          fullHeight: true,
          // Main.vue：keepAlive === true 才不进 keep-alive；iframe 绝不能缓存旧文档
          keepAlive: true,
        },
      },
      {
        path: '/dev/studio',
        name: 'dev-studio',
        component: () => import('@/pages/dev/embed.vue'),
        meta: {
          title: 'dev',
          updateTitle: false,
          isDefaultChat: false,
          fullHeight: true,
          // Main.vue：keepAlive === true 才不进 keep-alive；iframe 绝不能缓存旧文档
          keepAlive: true,
        },
      },
    ],
  },
];

// staticRouter[静态路由] 预留
export const staticRouter: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login/index.vue'),
    meta: { title: 'login', updateTitle: true },
  },
  {
    // Standalone full-page render of one Vibe Coding app page — deliberately
    // outside layoutRouter so no sidebar/header is shown. Shareable URL opened
    // from the Apps detail preview ("整页打开"); the route guard still
    // requires a token since page content comes from the Controller apps API.
    path: '/apps/:id/:slug/full',
    name: 'appViewFull',
    component: () => import('@/pages/app-view/index.vue'),
    meta: { title: 'apps', updateTitle: false },
  },
  {
    // Mini-program web-view cannot postMessage into the framed app; this page
    // sits on the chat-ui origin (SPA try_files) and injects yyia-embed auth.
    // Must stay outside the layout and on the router white list — the web-view
    // has no Pinia session.
    path: EMBED_BRIDGE_PATH,
    name: 'embedBridge',
    component: () => import('@/pages/embed-bridge/index.vue'),
    meta: { title: 'apps', updateTitle: false },
  },
];

// errorRouter (错误页面路由)
export const errorRouter = [
  {
    path: '/403',
    name: '403',
    component: () => import('@/pages/error/403.vue'),
    meta: {
      title: 'forbidden',
      updateTitle: false,
      enName: '403 Page', // 英文名称
      icon: 'QuestionFilled', // 菜单图标
      isHide: '1', // 代表路由在菜单中是否隐藏，是否隐藏[0隐藏，1显示]
      isLink: '1', // 是否外链[有值则是外链]
      isKeepAlive: '0', // 是否缓存路由数据[0是，1否]
      isFull: '1', // 是否缓存全屏[0是，1否]
      isAffix: '1', // 是否缓存固定路由[0是，1否]
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/pages/error/404.vue'),
    meta: {
      title: 'notFound',
      updateTitle: false,
      enName: '404 Page', // 英文名称
      icon: 'CircleCloseFilled', // 菜单图标
      isHide: '1', // 代表路由在菜单中是否隐藏，是否隐藏[0隐藏，1显示]
      isLink: '1', // 是否外链[有值则是外链]
      isKeepAlive: '0', // 是否缓存路由数据[0是，1否]
      isFull: '1', // 是否缓存全屏[0是，1否]
      isAffix: '1', // 是否缓存固定路由[0是，1否]
    },
  },
  // 找不到path将跳转404页面
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/pages/error/404.vue'),
  },
];
